module.exports = __webpack_public_path__ + "img/white-upload.38a4062a.svg";